var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHugeLogo = function SvgHugeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 130,
    viewBox: "0 0 405 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m159.474 91.046-15.433-21.853-3.97 5.139v16.714h-10.848v-54.38h10.848v24.217l18.021-24.216h13.371l-20.237 25.515 21.608 28.864h-13.36ZM218.725 91.022l-9.785-19.316h-7.759v19.316h-10.577V36.667h23.287c10.374 0 16.794 7.417 16.794 17.549 0 9.535-5.595 14.741-10.974 16.133l11.274 20.697-12.26-.024Zm1.071-36.912c0-4.48-3.215-7.253-7.384-7.253h-11.231v14.66h11.199c4.18 0 7.384-2.762 7.384-7.407h.032ZM250.363 68.696v-32.03h11.182v31.708c0 7.45 4.205 12.578 12.223 12.578 8.017 0 12.143-5.128 12.143-12.578V36.667h11.294v32.03c0 13.209-7.637 22.349-23.482 22.349-15.845 0-23.36-9.175-23.36-22.35ZM316.59 91.034V81.67l24.04-34.809h-24.04V36.667h38.229v9.293l-24.04 34.891h24.577v10.195l-38.766-.012ZM376.355 91.046v-54.38h35.514v10.195h-24.85v11.412h24.299v10.183h-24.277v12.395h24.85v10.195h-35.536Z",
    fill: "#404042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.904.298H52.235L0 54.657h51.952L103.904.297Z",
    fill: "url(#huge-logo_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1 128.84 51.67 54.955 0 0v54.657l96.1 74.183Z",
    fill: "#4791CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.359 46.453h1.295l-2.363-3.918c.57-.187 1.01-.51 1.322-.97.311-.458.476-1.015.494-1.67 0-.909-.272-1.62-.815-2.136-.534-.514-1.321-.772-2.363-.772h-2.256v9.466h1.082v-3.736h1.401l2.203 3.736Zm-3.604-4.705V37.97h1.241c1.344 0 2.016.632 2.016 1.896 0 .553-.165 1.007-.494 1.363-.32.346-.788.52-1.402.52h-1.361Z",
    fill: "#404042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.234 41.667c0 4.602-3.546 8.333-7.92 8.333-4.375 0-7.921-3.73-7.921-8.333s3.546-8.334 7.921-8.334c4.374 0 7.92 3.731 7.92 8.334Zm-.98 0c0 4.032-3.108 7.301-6.94 7.301-3.833 0-6.941-3.269-6.941-7.301 0-4.033 3.108-7.302 6.941-7.302 3.832 0 6.94 3.27 6.94 7.302Z",
    fill: "#404042"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "huge-logo_svg__a",
    x1: 51.952,
    y1: 54.657,
    x2: 51.952,
    y2: 0.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#034C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#035787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0274A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#00A3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADE5"
  })))));
};
export default SvgHugeLogo;